import { useMemo } from "react"
import {
  Avatar,
  Box,
  Card,
  CardProps,
  Divider,
  Typography,
  useTheme,
} from "@mui/material"
import { deepmerge } from "@mui/utils"
import BookIcon from "@mui/icons-material/Book"

import { getIcon } from "utils/icon"
import { useTranslation } from "providers/i18n"
import { get } from "lodash"

export interface IContactCardData {
  contactType: "phone"
  values: string[]
}

export interface IContactCardProps extends CardProps {
  data: IContactCardData
}

export const ReservationContactCard: React.FC<IContactCardProps> = ({
  sx = {},
  data,
  ...props
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const {
    root,
    logoContainer,
    logo: logoStyle,
    fallbackLogoIcon,
    divider,
    textContainer,
    primaryText: primaryTextStyle,
    labelContainer,
    label,
    contactTypeLabel,
    list,
  } = theme.components[`ReservationContactCard`]?.styleOverrides || {}

  const { contactType, values } = data || {}

  const fallbackIcon = useMemo(
    () =>
      getIcon(
        get(theme, `assets.reservationContactCard[${contactType}]`),
        fallbackLogoIcon,
        {
          iconCompProps: {
            className: "ReservationContactCard-fallbackLogoIcon",
          },
        }
      ) || (
        <BookIcon
          sx={fallbackLogoIcon}
          className="ReservationContactCard-fallbackLogoIcon"
        />
      ),
    [theme, contactType, fallbackLogoIcon]
  )

  return (
    <Card sx={deepmerge(root, sx)} {...props}>
      <Box sx={logoContainer}>
        <Avatar sx={logoStyle}>{fallbackIcon}</Avatar>
      </Box>
      <Divider sx={divider} />
      <Box sx={labelContainer}>
        <Typography sx={label}>{t("Book by")}</Typography>
        <Typography sx={contactTypeLabel}>{t(contactType)}</Typography>
      </Box>
      <Box sx={textContainer}>
        <Box sx={list}>
          {values.map((v, index) =>
            v ? (
              <Typography key={`${v}-${index}`} sx={primaryTextStyle}>
                {t(v)}
              </Typography>
            ) : null
          )}
        </Box>
      </Box>
    </Card>
  )
}
